import { setLocalStorage } from "./handlingStorage";
import { isLoggedIn } from "./helper";
import {unlockArticles} from "./unlockArticles";

document.addEventListener('DOMContentLoaded', function () {
    let togglepassword = document.getElementById('toggle-password');
    let passwordField = document.getElementById('login-form-password');

    // toggle Passwort-Sichtbarkeit wenn Loginform vorhanden ist
    if(togglepassword && passwordField)
    {
        togglepassword.addEventListener('click', function () {
        passwordField.type = passwordField.type === 'password' ? 'text' : 'password';
        // Toggle Icon des Passwort-sichtbar-Feldes
        if (passwordField.type === 'password') {
            togglepassword.classList.add('before:content-eye-off');
        } else {
            togglepassword.classList.remove('before:content-eye-off');
            togglepassword.classList.remove('cursor-pointer');
            togglepassword.classList.add('before:content-eye');
        }
        });
    }

    // Button des Loginformulares erst aktivieren wenn Formular ausgefuellt ist
    const form = document.getElementById('login-form');
    const submitButton = document.getElementById('login-form-button-submit');

    if(form && submitButton)
    {
        // Funktion zur Überprüfung der Formularvalidität
        form.addEventListener('input', function () {
            if (form.checkValidity()) {
                submitButton.classList.add('bg-linear-to-r', 'from-primary-background', 'from-39%', 'to-primary-background-dark', 'to-86%', 'hover:cursor-pointer', 'transition-all', 'duration-200', 'ease-in-out', 'hover:scale-105', 'hover:shadow-big');
                submitButton.classList.remove('bg-neutral', 'opacity-10', 'cursor-auto');
            } else {
                submitButton.classList.remove('bg-linear-to-r', 'from-primary-background', 'from-39%', 'to-primary-background-dark', 'to-86%', 'hover:cursor-pointer', 'transition-all', 'duration-200', 'ease-in-out', 'hover:scale-105', 'hover:shadow-big');
                submitButton.classList.add('bg-neutral', 'opacity-10', 'cursor-auto');
            }
        });
    }

    // Fehlermeldungen anzeigen
    let url = new URL(window.location);
    let error = url.searchParams.has("error");
    if(error)
    {
        const username = document.getElementById('login-form-username');
        const password = document.getElementById('login-form-password');
        if(username)
        {
            username.classList.remove('bg-transparent', 'border-neutral-border', 'text-neutral', 'focus:ring-neutral-ring/30', 'focus:border-neutral-ring/80');
            username.classList.add('bg-destructive/10', 'border-destructive', 'text-destructive', 'focus:ring-destructive/20', 'focus:border-destructive');
        }
        if(username)
        {
            password.classList.remove('bg-transparent', 'border-neutral-border', 'text-neutral', 'focus:ring-neutral-ring/30', 'focus:border-neutral-ring/80');
            password.classList.add('bg-destructive/10', 'border-destructive', 'text-destructive', 'focus:ring-destructive/20', 'focus:border-destructive');
        }

    }

})


// Wenn Cookie gesetzt ist, soll MainMenuLoggedin angezeigt werden ueberschrieben werden
if(isLoggedIn())
{
    const user = IwwUserdata.USERDATA;

    if(document.getElementById('iww-mainheader-loggedin-username')){
        document.getElementById('iww-mainheader-loggedin-username').innerText = user.vorname + " "+ user.nachname ;
    }

    let list = document.getElementById('iww-mainheader-loggedin-abos');
    if(list){
        for(let i = 0; i < user.infodienste.length; i++) {
            let entry = document.createElement("li");
            entry.classList.add("mr-5","group");
            let link = document.createElement("a");
            link.href = window.location.origin + "/" + user.infodienste[i].toLowerCase();
            link.innerText = user.infodienste[i];
            link.classList.add("text-base", "text-neutral-subtle", "relative", "hover:text-neutral-on-accent");
            entry.appendChild(link);
            list.appendChild(entry);
        }
    }


    document.addEventListener('DOMContentLoaded', function (event) {
        unlockArticles();
    });
    document.addEventListener('htmx:afterSettle', function (event) {
        unlockArticles();
    });
}

if (window.location.href.includes("/logout")) {
    setLocalStorage("logged_in", 0)
}
